import React, { useState, useEffect } from "react";
import { injectModels } from "../../redux/injectModels";
import {
  PaymentService,
  DocumentService,
  InvoiceService,
  DocumentTypeService,
} from "../../services";
import { toast } from "react-toastify";
import { PaymentStatus } from "../../constants/Enum";
import { routes } from "../../constants/routes";

import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import {
  formatAmount,
  formatDateENGB,
  handleConsoleError,
} from "../../utils/common-methods";
import { globalConstant } from "../../constants/globalConstant";
const html2pdf = require("html2pdf.js");

const TicketPaymentCard = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showError, setShowError] = useState(false);
  const [formValue, setFormValues] = useState({});
  const [appId, setAppId] = useState();
  const [isDocGenerated, setDocGenerated] = useState(false);

  const handlePaymentIntent = async () => {
    try {
      props.application.setLoading(true);
      if (
        props &&
        props.paymentDetails &&
        props.paymentDetails.isFinalPayment
      ) {
        // handleFinalPayment
        await handleFinalPayment();
      }
      props.application.setLoading(false);
    } catch (error) {
      const message = handleConsoleError(error);
      props.application.setLoading(false);
      toast.error(error?.message || message);
    }
  };

  // ******* For error ******
  const handlePaymentClick = () => {
    if (!isChecked) {
      setShowError(true);
    } else {
      setShowError(false);
      handlePaymentIntent();
    }
  };

  const handleFinalPayment = async () => {
    try {
      const amount = Number(formatAmount(props?.paymentDetails?.amount || 0));
      const ticketFeeAmount = Number(
        formatAmount(props?.paymentDetails?.ticketFeeAmount || 0)
      );
      const reqData = {
        amount: amount - ticketFeeAmount,
        connectedAccountId: props?.paymentDetails?.connectedAccountId,
        ticketFeeAmount: ticketFeeAmount,
      };
      const res = await PaymentService.createTicketPaymentIntent(reqData);
      if (res?.isSuccess) {
        if (res?.data) {
          const clientSecret = res?.data?.clientSecret;
          // Confirm the payment with the Stripe API
          const { error, paymentIntent } = await stripe.confirmCardPayment(
            clientSecret,
            {
              payment_method: {
                card: elements.getElement(CardElement),
              },
            }
          );
          if (paymentIntent) {
            //save payment details
            const paymentIntentDetails = {
              ticketid: props?.paymentDetails?.ticketid,
              request: JSON.stringify(reqData),
              response: JSON.stringify(paymentIntent),
              connectedAccount: props?.paymentDetails?.connectedAccountId,
              totalQty: props?.paymentDetails?.quantity,
              amount: amount - ticketFeeAmount,
              status: PaymentStatus.Paid,
              paymentIntentId: paymentIntent?.id,
              ticketAdminFee: ticketFeeAmount,
            };

            await savePaymentDetails(paymentIntentDetails);
            props?.onClose();
          } else {
            toast.error("Payment declined");
          }
        }
        props.application.setLoading(false);
      } else {
        toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        props.application.setLoading(false);
      }
    } catch (error) {
      const message = handleConsoleError(error);
      props.application.setLoading(false);
      toast.error(error?.message || message);
    }
  };

  const savePaymentDetails = async (paymentIntentDetails) => {
    try {
      props.application.setLoading(true);
      const response = await PaymentService.saveTicketPayment(
        paymentIntentDetails
      );
      if (response?.isSuccess) {
        //TODO :: Invoice generate
        const data = response?.data;
        setAppId(data?.id);
        await invoiceData(data?.id);
        //await sendingMail();
        toast.success(response?.message);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  //****   Invoice Data  *****
  const invoiceData = async (eventApplicationId) => {
    try {
      let Invoicebyid = {};
      const InvoiceByid = await InvoiceService.getInvoiceMainData(
        eventApplicationId,
        "T",
        false
      );
      if (InvoiceByid?.isSuccess) {
        Invoicebyid = InvoiceByid?.data;
        setFormValues((prev) => ({
          ...prev,
          Invoicebyid, // updated value
        }));

        await InvoiceAdminData(eventApplicationId);
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  //******  Invoice PDF CODE *****************
  const InvoicePdf = async (formValue) => {
    try {
      let html = globalConstant?.InvoiceTicketHTML;
      html = html
        .toString()
        .replace(
          "@vatNumber@",
          formValue?.Invoicebyid?.vatNo ?? ""
        )
        .replace(
          "@businessLogoUrl@",
          formValue?.Invoicebyid?.businessLogo || ""
        )
        .replace(
          "@businessRegistrationNumber@",
          formValue?.Invoicebyid?.vatNo ?? ""
        )
        .replace(
          "@vat@",
          formValue?.Invoicebyid?.vat ?? ""
        )
        .replace(
          "@invoiceNo@",
          formValue?.Invoicebyid?.invoiceNo ?? ""
        )
        .replace(
          "@address@",
          formValue?.Invoicebyid?.city ?? ""
        )
        .replace(
          "@invoiceAddress@",
          formValue?.Invoicebyid?.invoiceAddress
            ??  ""
        )
        .replace(
          "@eventName@",
          formValue?.Invoicebyid?.eventName ?? ""
        )
        .replace(
          "@organiserLegalBusinessName@",
          formValue?.Invoicebyid?.organiserLegalBusinessName
            ?? ""
        )
        .replace(
          "@organiserLegalBusinessName@/g",
          formValue?.Invoicebyid?.organiserLegalBusinessName
            ?? ""
        )
        .replace(
          "@organiserAddress@",
          formValue?.Invoicebyid?.organiserAddress
            ?? ""
        )
        .replace(
          "@traderLegalBusinessName@",
          formValue?.Invoicebyid?.traderLegalBusinessName
            ?? ""
        )
        .replace(
          "@invoiceDate@",
          formValue?.Invoicebyid?.invoiceDate
            ? formatDateENGB(formValue?.Invoicebyid?.invoiceDate)
            : ""
        )
        .replace(
          "@traderAddress@",
          formValue?.Invoicebyid?.traderAddress
            ?? ""
        )

        //Table

        .replace(
          "@litterBond@",
          formValue?.Invoicebyid?.litterBond
            ? "£" + formatAmount(formValue?.Invoicebyid?.litterBond)
            : ""
        )
        .replace(
          "@tax@",
          formValue?.Invoicebyid?.vat
            ? "£" + formatAmount(formValue?.Invoicebyid?.vat)
            : ""
        )
        .replace(
          "@subTotal@",
          formValue?.Invoicebyid?.totalAmount
            ? "£" +
                formatAmount(
                  formValue?.Invoicebyid?.totalAmount -
                    (formValue?.Invoicebyid?.vat
                      ? formValue?.Invoicebyid?.vat
                      : 0) -
                    (formValue?.Invoicebyid?.litterBond
                      ? formValue?.Invoicebyid?.litterBond
                      : 0)
                )
            : ""
        )
        .replace(
          "@balancedue@",
          "£" +
            formatAmount(
              formValue?.Invoicebyid?.totalAmount
                ?? 0
            )
        )

        // Table
        .replace(
          " @table@",
          (formValue?.Invoicebyid?.objInvoiceDetailListViewModel ?? [])
            .map(
              (msd) =>
                `<tr>
                      <td  >${msd?.qty ?? "-"}</td>
                      <td >${msd?.item ?? "-"}</td>
                      <td >${msd?.description ?? "-"}</td>
                       <td>N/A</td>
                      <td>${msd.taxable === true ? "Yes" : "No"}</td>
                      <td >${
                        msd.unitPrice ? "£" + formatAmount(msd?.unitPrice) : "-"
                      }</td>
                      <td>${
                        msd.unitPrice && msd.qty
                          ? "£" + formatAmount(msd?.unitPrice * msd?.qty)
                          : "-"
                      }</td>
                </tr> `
            )
            .join("")
        );

      const opt = {
        margin: [20, 20, 20, 20],
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        filename: `Ticket_Invoice.pdf`,
        image: { type: "jpeg", quality: 0.2 },
        html2canvas: {
          dpi: 50,
          scale: 3,
          letterRendering: true,
          useCORS: true,
          // scrollY: 2,
        },
        jsPDF: {
          unit: "pt",
          format: "a4",
          orientation: "portrait",
          putTotalPages: true,
          before: ".nextpage1",
          compress: true,
        },
      };

      return new Promise((resolve, reject) => {
        html2pdf()
          .set(opt)
          .from(html)
          .toPdf()
          .output("blob") // Generate the PDF as a Blob
          .then((pdfBlob) => {
            const file = new File([pdfBlob], "Ticket_Invoice.pdf", {
              type: "application/pdf",
            });
            resolve(file); // Return the PDF as a File object
          })
          .catch((error) => {
            handleConsoleError(error);
            reject(error);
          });
      });
    } catch (error) {
      handleConsoleError(error);
      throw error;
    }
  };

  //
  //****   Invoice Admin Data  *****
  const InvoiceAdminData = async (eventApplicationId) => {
    try {
      let invoiceAdmin = {};
      const resInvoiceByid = await InvoiceService.getInvoiceMainData(
        eventApplicationId,
        "T",
        true
      );
      if (resInvoiceByid?.isSuccess) {
        invoiceAdmin = resInvoiceByid?.data;
        setFormValues((prev) => ({
          ...prev,
          invoiceAdmin, // updated value
        }));
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  //******  Invoice Admin PDF CODE *****************
  const InvoiceAdminPdf = async (formValue) => {
    try {
      let html = globalConstant?.InvoiceAdminHTML;

      const adminItemList =
        formValue.invoiceAdmin?.objInvoiceDetailListViewModel?.filter(
          (x) =>
            x.item.toLowerCase().includes("application") ||
            x.item.toLowerCase().includes("buyer")
        ) ?? [];

      // formValue.invoiceAdmin.totalAmount = adminItemList.reduce(
      //   ((acc, x) => acc + x.unitPrice * x.qty, 0)
      // );
      // formValue.invoiceAdmin.totalAmount = adminItemList.reduce(
      //   (acc, item) => acc + item.unitPrice * item.qty,
      //   0
      // );

      html = html
        .toString()
        .replace(
          "@vatNumber@",
          formValue?.invoiceAdmin?.vatNo ?? ""
        )
        .replace(
          "@businessLogoUrl@",
          formValue?.invoiceAdmin?.businessLogo ?? ""
        )
        .replace(
          "@businessRegistrationNumber@",
          formValue?.invoiceAdmin?.vatNo ??  ""
        )
        .replace(
          "@vat@",
          formValue?.invoiceAdmin?.vat ?? ""
        )
        .replace(
          "@invoiceNo@",
          formValue?.invoiceAdmin?.invoiceNo
            ??  ""
        )
        .replace(
          "@address@",
          formValue?.invoiceAdmin?.city ?? ""
        )
        .replace(
          "@invoiceAddress@",
          formValue?.invoiceAdmin?.invoiceAddress
            ?? ""
        )
        .replace(
          "@businessLogoUrl@",
          formValue?.invoiceAdmin?.businessLogoUrl
            ?? ""
        )
        .replace(
          "@eventName@",
          formValue?.invoiceAdmin?.eventName
            ?? ""
        )
        .replace(
          "@organiserLegalBusinessName@",
          formValue?.invoiceAdmin?.organiserLegalBusinessName
            ?? ""
        )
        .replace(
          "@organiserLegalBusinessName@/g",
          formValue?.invoiceAdmin?.organiserLegalBusinessName
            ?? ""
        )
        .replace(
          "@organiserAddress@",
          formValue?.invoiceAdmin?.organiserAddress
            ??  ""
        )
        .replace(
          "@traderLegalBusinessName@",
          formValue?.invoiceAdmin?.traderLegalBusinessName
            ??  ""
        )
        .replace(
          "@invoiceDate@",
          formValue?.invoiceAdmin?.invoiceDate
            ? formatDateENGB(formValue.invoiceAdmin.invoiceDate)
            : ""
        )
        .replace(
          "@traderAddress@",
          formValue?.invoiceAdmin?.traderAddress
            ?? ""
        )

        //Table

        .replace(
          "@litterBond@",
          formValue?.invoiceAdmin?.litterBond
            ? "£" + formatAmount(formValue.invoiceAdmin.litterBond)
            : ""
        )
        .replace(
          "@tax@",
          formValue?.invoiceAdmin?.vat
            ? "£" + formatAmount(formValue.invoiceAdmin.vat)
            : ""
        )
        .replace(
          "@subTotal@",
          formValue?.invoiceAdmin?.totalAmount
            ? "£" +
                formatAmount(
                  formValue?.invoiceAdmin?.totalAmount -
                    (formValue?.invoiceAdmin?.vat
                      ? formValue?.invoiceAdmin?.vat
                      : 0) -
                    (formValue?.invoiceAdmin?.litterBond
                      ? formValue?.invoiceAdmin?.litterBond
                      : 0)
                )
            : ""
        )
        .replace(
          "@balancedue@",
          "£" +
            formatAmount(
              formValue?.invoiceAdmin?.totalAmount
                ?? 0
            )
        )

        // Table
        .replace(
          " @table@",
          adminItemList
            .map(
              (msd) =>
                `<tr>
                        <td>${msd?.qty ??  "-"}</td>
                        <td>${msd?.item ?? "-"}</td>
                        <td>${msd?.description ??  "-"}</td>
                         <td>N/A</td>
                        <td>${msd?.taxable === true ? "Yes" : "No"}</td>
                        <td>${
                          msd?.unitPrice
                            ? "£" + formatAmount(msd?.unitPrice)
                            : "-"
                        }</td>
                        <td>${
                          msd?.unitPrice && msd?.qty
                            ? "£" + formatAmount(msd?.unitPrice * msd?.qty)
                            : "-"
                        }</td>
                  </tr> `
            )
            .join("")
        );

      const opt = {
        margin: [20, 20, 20, 20],
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        filename: `Ticket_Admin_Invoice.pdf`,
        image: { type: "jpeg", quality: 0.2 },
        html2canvas: {
          dpi: 150,
          scale: 2,
          letterRendering: true,
          useCORS: true,
          // scrollY: 2,
        },
        jsPDF: {
          unit: "pt",
          format: "a4",
          orientation: "portrait",
          putTotalPages: true,
          before: ".nextpage1",
          compress: true,
        },
      };

      return new Promise((resolve, reject) => {
        html2pdf()
          .set(opt)
          .from(html)
          .toPdf()
          .output("blob") // Generate the PDF as a Blob
          .then((pdfBlob) => {
            const file = new File([pdfBlob], "Ticket_Admin_Invoice.pdf", {
              type: "application/pdf",
            });
            resolve(file); // Return the PDF as a File object
          })
          .catch((error) => {
            handleConsoleError(error);
            reject(error);
          });
      });
    } catch (error) {
      handleConsoleError(error);
      throw error;
    }
  };

  const sendingMail = async () => {
    props.application.setLoading(true);
    try {
      //Invoice PDF
      const invoice = await InvoicePdf(formValue);
      const requestData = {
        EventApplicationId: appId,
        ApplicationFor: "T",
        DocumentType: 0,
        DocumentFile: invoice,
      };
      const response = await DocumentService.EventApplicationAddDocument(
        requestData
      );
      if (response?.isSuccess) {
        // toast.success(response?.message);
      } else {
        toast.error(response?.message);
        props.application.setLoading(false);
      }

      //InvoiceAdmin
      const invoiceAdmin = await InvoiceAdminPdf(formValue);
      const requestAdminData = {
        EventApplicationId: appId,
        ApplicationFor: "T",
        DocumentType: 4,
        DocumentFile: invoiceAdmin,
      };
      const responseAdmin = await DocumentService.EventApplicationAddDocument(
        requestAdminData
      );
      if (responseAdmin?.isSuccess) {
        // toast.success(response?.message);

        const response = await DocumentTypeService.sendEventTicketInvoiceByAppId(
          appId
        );
        if (response?.isSuccess) {
          // console.log("Invoice Email send ");
        }
        props.application.setLoading(false);
      } else {
        toast.error(responseAdmin?.message);
        props.application.setLoading(false);
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const handleCardError = (event) => {
    setIsValid(event?.complete ?? false);
    if (event?.complete) {
      setError("");
    } else if (event?.error) {
      setError(event?.error?.message);
    }
  };

  useEffect(() => {
    checkConnectedAccountExits();
  }, []);

  useEffect(() => {
    if (formValue?.invoiceAdmin) {
      if (!isDocGenerated) {
        sendingMail();
        setDocGenerated(true);
      }
    }
  }, [formValue.invoiceAdmin]);

  const checkConnectedAccountExits = async () => {
    if (!props?.paymentDetails?.connectedAccountId) {
      setError("Connected account not found");
    }
    // await invoiceData(appId);
  };

  return (
    <React.Fragment>
      <section className="loginswallow">
        {/* <h3>{props?.paymentDetails?.title}</h3> */}
        <div className="form-container">
          <div className="row mb-3">
            <div className="col-sm-12">
              <h3>{props?.eventData?.eventName}</h3>
              <hr />
              <h4 style={{ fontSize: "24px", fontWeight: "600" }}>
                Payment details summary
              </h4>
            </div>
          </div>

          <React.Fragment>
            <div className="row mb-3">
              <div className="col-sm-6">
                <span>
                  <h4>{`${props?.paymentDetails?.title} X ${props?.paymentDetails?.quantity}`}</h4>
                </span>
              </div>
              <div className="col-sm-6">
                <strong>
                  <h4>£{formatAmount(props?.lineItems[2]?.amount)}</h4>
                </strong>
              </div>
            </div>
            {(props?.lineItems ?? []).map((lineItem, index) => (
              <>
                {index === +3 && <hr />}
                <div key={index} className="row mb-3">
                  <div className="col-sm-6">
                    {index === 3 ? (
                      <h4>
                        <span>{lineItem?.name}</span>
                      </h4>
                    ) : (
                      <span>{lineItem?.name}</span>
                    )}
                  </div>
                  <div className="col-sm-6">
                    {index === 2 ? (
                      <h4>
                        <strong>£{formatAmount(lineItem?.total)}</strong>
                      </h4>
                    ) : (
                      <strong>£{formatAmount(lineItem?.total)}</strong>
                      // <strong>
                      //   £
                      //   {index === 1
                      //     ? formatAmount(lineItem.total)
                      //     : formatAmount(lineItem.amount)}
                      // </strong>
                    )}
                  </div>
                </div>
              </>
            ))}
          </React.Fragment>

          <div className="row mb-3">
            <div className="col-sm-12">
              <span style={{ fontSize: "14px", fontWeight: "600" }}>
                Please enter your card details in order to complete your
                purchase.
              </span>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-12">
              <CardElement className="mb-3" onChange={handleCardError} />

              {error && <div style={{ color: "red" }}>{error}</div>}
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-12">
              <div
                className="d-flex align-center"
                style={{ gap: "10px", flexDirection: "column" }}
              >
                {/* <span
                      style={{ color: "blue", textDecoration: "underline", cursor: "pointer", fontSize: "14px" }}
                      onClick={() => navigate(routes.MANAGE_PAYMENT_TERMS)}
                    >
                      View Payment & Terms Details
                    </span> */}

                <div className="d-flex align-center" style={{ gap: "10px" }}>
                  <input
                    type="radio"
                    style={{ width: "19px", padding: "0px", height: "19px" }}
                    checked={isChecked}
                    onChange={() => {
                      setIsChecked(!isChecked);
                      setShowError(false);
                    }}
                  />
                  I accept the
                  <a
                    style={{
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontSize: "14px",
                      margin: "0px",
                      fontWeight: "600",
                    }}
                    href={routes.MANAGE_PAYMENT_TERMS}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Payment Terms
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div
                className="d-flex align-items-center justify-content-center flex-column"
                style={{ gap: "10px" }}
              >
                <h4>We accept the following cards</h4>
                <img
                  width={"180"}
                  src="/assets/images/6220ac0f912013c51947f9c4.png"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-12">
              <button
                type="button"
                style={{ backgroundColor: isValid ? "#ed307c" : "#adb5bd" }}
                disabled={!isValid}
                onClick={handlePaymentClick}
              >
                Pay
              </button>
              {showError && (
                <p style={{ color: "red", marginTop: "5px" }}>
                  Please accept the terms to proceed!
                </p>
              )}
              {/* {isValid && (
                <button type="button" disabled={isValid}>
                  Pay
                </button>
              )}{" "}
              {!isValid && (
                <button
                  type="button"
                  disabled={isValid}
                  onClick={handlePaymentIntent}
                >
                  Pay
                </button>
              )} */}
            </div>
          </div>

          <div className="row ">
            <div className="col-sm-12">
              <div
                className="d-flex align-center justify-content-center"
                style={{ gap: "10px" }}
              >
                <img src="/assets/images/secure-logos.png" alt=""></img>
              </div>
            </div>
          </div>
          <div className="row ">
            <div className="col-sm-12">
              <div
                className="d-flex align-center justify-content-center"
                style={{ gap: "10px" }}
              >
                <p>
                  {" "}
                  Our application is hosted on Microsoft data centres, which are
                  ISO/IEC 27001, 27017, and 27018 certified.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};
export default injectModels(["auth", "application"])(TicketPaymentCard);
